module.exports = __webpack_public_path__ + "img/location_services_en.fb3cb344.svg";